var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.disclaimerContent)?_c('div',{staticClass:"qualification-disclaimer"},[_vm._v("\n  "+_vm._s(_vm.disclaimerContent)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }